/* =====================================================
   EFDA / COMMON SCROLL ANIMATION
   HERO・LOADERは対象外
   ===================================================== */

(function () {
    'use strict';


    /* =====================================================
       二重読み込み防止
       ===================================================== */

    if (window.__EFDACommonAnimationLoaded) {
        return;
    }

    window.__EFDACommonAnimationLoaded = true;



    /* =====================================================
       SETTINGS
       ===================================================== */

    const NORMAL_OPTIONS = {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: 0
    };


    const STAGGER_OPTIONS = {
        root: null,
        rootMargin: '0px 0px -25% 0px',
        threshold: 0
    };


    const COUNT_OPTIONS = {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: 0
    };


    const COUNT_DEFAULT_DURATION = 1400;


    const prefersReducedMotion =
        window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;


    const supportsIntersectionObserver =
        'IntersectionObserver' in window;



    /* =====================================================
       COUNT UP
       ===================================================== */

    function easeOutCubic(value) {

        return 1 - Math.pow(
            1 - value,
            3
        );
    }



    function startCountUp(counter) {

        if (!counter) {
            return;
        }


        if (
            counter.dataset.efdaCountDone ===
            'true'
        ) {
            return;
        }


        counter.dataset.efdaCountDone =
            'true';


        const target =
            Number(
                counter.dataset.countTo ||
                0
            );


        const duration =
            Number(
                counter.dataset.countDuration ||
                COUNT_DEFAULT_DURATION
            );


        let startTime = null;



        function update(timestamp) {

            if (startTime === null) {

                startTime =
                    timestamp;
            }


            const elapsed =
                timestamp -
                startTime;


            const progress =
                Math.min(
                    elapsed / duration,
                    1
                );


            const eased =
                easeOutCubic(
                    progress
                );


            const current =
                Math.round(
                    target *
                    eased
                );


            counter.textContent =
                current.toLocaleString(
                    'ja-JP'
                );


            if (progress < 1) {

                window.requestAnimationFrame(
                    update
                );

                return;
            }


            counter.textContent =
                target.toLocaleString(
                    'ja-JP'
                );
        }


        window.requestAnimationFrame(
            update
        );
    }



    /* =====================================================
       PARENT SYNC COUNT UP

       親要素のFade Upなどと
       Count Upを同期させる

       使用例：

       data-count-trigger="parent"
       data-count-delay="550"
       ===================================================== */

    function startParentCountUps(element) {

        if (!element) {
            return;
        }


        const counters =
            element.querySelectorAll(
                '.EFDA-countup[data-count-trigger="parent"]'
            );


        counters.forEach(
            function (counter) {


                if (
                    counter.dataset.efdaCountDone ===
                    'true'
                ) {
                    return;
                }


                if (
                    counter.dataset.efdaCountScheduled ===
                    'true'
                ) {
                    return;
                }


                counter.dataset.efdaCountScheduled =
                    'true';


                const delay =
                    Number(
                        counter.dataset.countDelay ||
                        0
                    );


                window.setTimeout(
                    function () {

                        startCountUp(
                            counter
                        );

                    },
                    delay
                );

            }
        );
    }



    /* =====================================================
       SHOW
       ===================================================== */

    function showAnimation(element) {

        if (!element) {
            return;
        }


        element.classList.add(
            'is-visible'
        );


        element.dataset.efdaAnimationDone =
            'true';


        /*
         * 親同期Count Up
         */

        if (
            !prefersReducedMotion &&
            supportsIntersectionObserver
        ) {

            startParentCountUps(
                element
            );
        }
    }



    /* =====================================================
       STAGGER PREPARE

       直下の子要素へ
       --EFDA-stagger-index を設定
       ===================================================== */

    function prepareStagger(group) {

        if (!group) {
            return;
        }


        Array.from(
            group.children
        ).forEach(
            function (child, index) {

                child.style.setProperty(
                    '--EFDA-stagger-index',
                    index
                );

            }
        );
    }



    /* =====================================================
       NORMAL OBSERVER

       Fade Up
       Blur
       Zoom Out
       Grow Up
       Sequence
       ===================================================== */

    const normalObserver =
        (
            !prefersReducedMotion &&
            supportsIntersectionObserver
        )
            ? new IntersectionObserver(

                function (entries, observer) {

                    entries.forEach(
                        function (entry) {

                            if (
                                !entry.isIntersecting
                            ) {
                                return;
                            }


                            showAnimation(
                                entry.target
                            );


                            observer.unobserve(
                                entry.target
                            );
                        }
                    );

                },

                NORMAL_OPTIONS
            )

            : null;



    /* =====================================================
       STAGGER OBSERVER
       ===================================================== */

    const staggerObserver =
    (!prefersReducedMotion && supportsIntersectionObserver)
        ? new IntersectionObserver(function (entries, observer) {

            entries.forEach(function (entry) {

                if (!entry.isIntersecting) return;

                /*
                 * 子要素を監視している場合があるので、
                 * 本来の .EFDA-anim-stagger 要素まで遡って表示させる
                 */
                const group =
                    entry.target.closest('.EFDA-anim-stagger') || entry.target;

                showAnimation(group);

                observer.unobserve(entry.target);
            });

        }, STAGGER_OPTIONS)
        : null;



    /* =====================================================
       COUNT OBSERVER
       ===================================================== */

    const countObserver =
        (
            !prefersReducedMotion &&
            supportsIntersectionObserver
        )
            ? new IntersectionObserver(

                function (entries, observer) {

                    entries.forEach(
                        function (entry) {

                            if (
                                !entry.isIntersecting
                            ) {
                                return;
                            }


                            startCountUp(
                                entry.target
                            );


                            observer.unobserve(
                                entry.target
                            );
                        }
                    );

                },

                COUNT_OPTIONS
            )

            : null;



    /* =====================================================
       PAGE INITIALIZE
       ===================================================== */

    function initializePage(page) {

        if (!page) {
            return;
        }


        page.classList.add(
            'EFDA-js-enabled'
        );



        /* =================================================
           STAGGER INDEX準備

           通常Stagger
           ＋
           Sequence Stagger
           ================================================= */

        page
            .querySelectorAll(
                '.EFDA-anim-stagger, .EFDA-sequence--stagger'
            )
            .forEach(
                function (group) {

                    prepareStagger(
                        group
                    );

                }
            );



        /* =================================================
           REDUCED MOTION
           ================================================= */

        if (
            prefersReducedMotion ||
            !supportsIntersectionObserver
        ) {


            page
                .querySelectorAll(
                    '.EFDA-anim, .EFDA-anim-stagger'
                )
                .forEach(
                    function (element) {

                        showAnimation(
                            element
                        );

                    }
                );


            page
                .querySelectorAll(
                    '.EFDA-countup'
                )
                .forEach(
                    function (counter) {

                        const target =
                            Number(
                                counter.dataset.countTo ||
                                counter.textContent ||
                                0
                            );


                        counter.textContent =
                            target.toLocaleString(
                                'ja-JP'
                            );


                        counter.dataset.efdaCountDone =
                            'true';

                    }
                );


            return;
        }



        /* =================================================
           NORMAL
           ================================================= */

        page
            .querySelectorAll(
                '.EFDA-anim:not(.EFDA-anim-stagger)'
            )
            .forEach(
                function (element) {


                    if (
                        element.dataset.efdaAnimationDone ===
                        'true'
                    ) {
                        return;
                    }


                    if (
                        element.dataset.efdaNormalObserved ===
                        'true'
                    ) {
                        return;
                    }


                    element.dataset.efdaNormalObserved =
                        'true';


                    normalObserver.observe(
                        element
                    );

                }
            );



        /* =================================================
           STAGGER
           ================================================= */

        page
    .querySelectorAll('.EFDA-anim-stagger')
    .forEach(function (group) {

        if (group.dataset.efdaAnimationDone === 'true') return;
        if (group.dataset.efdaStaggerObserved === 'true') return;

        group.dataset.efdaStaggerObserved = 'true';

        /*
         * display:contents はボックスを持たないため
         * IntersectionObserverが交差を検知できない。
         * その場合は代わりに最初の子要素を監視する。
         */
        const isContents =
            window.getComputedStyle(group).display === 'contents';

        const observeTarget =
            (isContents && group.firstElementChild)
                ? group.firstElementChild
                : group;

        staggerObserver.observe(observeTarget);
    });



        /* =================================================
           COUNT UP
           ================================================= */

        page
            .querySelectorAll(
                '.EFDA-countup'
            )
            .forEach(
                function (counter) {


                    if (
                        counter.dataset.efdaCountDone ===
                        'true'
                    ) {
                        return;
                    }


                    /*
                     * JSが動いている場合だけ
                     * 初期値を0にする
                     */

                    if (
                        counter.dataset.efdaCountPrepared !==
                        'true'
                    ) {

                        counter.dataset.efdaCountPrepared =
                            'true';


                        counter.textContent =
                            '0';
                    }


                    /*
                     * 親アニメーションと同期するものは
                     * 独立Observerには登録しない
                     */

                    if (
                        counter.dataset.countTrigger ===
                        'parent'
                    ) {
                        return;
                    }


                    if (
                        counter.dataset.efdaCountObserved ===
                        'true'
                    ) {
                        return;
                    }


                    counter.dataset.efdaCountObserved =
                        'true';


                    countObserver.observe(
                        counter
                    );

                }
            );
    }



    /* =====================================================
       ROOT INITIALIZE
       ===================================================== */

    function initializeAnimations(root) {

        const scope =
            root ||
            document;


        const pages =
            [];


        /*
         * scope自身がEFDA-page
         */

        if (
            scope.nodeType === 1 &&
            scope.matches &&
            scope.matches('.EFDA-page')
        ) {

            pages.push(
                scope
            );
        }


        /*
         * scope配下
         */

        if (
            scope.querySelectorAll
        ) {

            scope
                .querySelectorAll(
                    '.EFDA-page'
                )
                .forEach(
                    function (page) {

                        if (
                            !pages.includes(
                                page
                            )
                        ) {

                            pages.push(
                                page
                            );
                        }

                    }
                );
        }


        /*
         * Shopify Sectionが
         * EFDA-page内部の場合
         */

        if (
            scope.nodeType === 1 &&
            scope.closest
        ) {

            const parentPage =
                scope.closest(
                    '.EFDA-page'
                );


            if (
                parentPage &&
                !pages.includes(
                    parentPage
                )
            ) {

                pages.push(
                    parentPage
                );
            }
        }


        pages.forEach(
            function (page) {

                initializePage(
                    page
                );

            }
        );
    }



    /* =====================================================
       BOOT
       ===================================================== */

    function boot() {

        initializeAnimations(
            document
        );


        /*
         * Shopify Theme Editor
         */

        document.addEventListener(
            'shopify:section:load',
            function (event) {

                initializeAnimations(
                    event.target
                );

            }
        );
    }


    if (
        document.readyState ===
        'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            boot,
            {
                once: true
            }
        );

    } else {

        boot();
    }

})();